<template>
  <v-app-bar
    prominent
    elevation="0"
    :color="appBarColor"
  >
    <v-container class="pt-0">
      <v-row justify="space-between">
        <v-col cols="auto pt-5">
          <reward-link-logo
            width="167"
            height="45"
            :color="logoColor"
          />
        </v-col>
        <v-col cols="auto">
          <v-btn
            id="wallet-header-menu-btn"
            fab
            elevation="0"
            text
            large
          >
            <v-icon
              color="logoColor"
              size="32"
            >
              mdi-menu
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import RewardLinkLogo from '@/components/footer/RewardLinkLogo'
import { TangoCardColors } from '@tangocard/swag'
export default {
  name: 'WalletHeader',
  components: {
    RewardLinkLogo
  },
  computed: {
    appBarColor: () => TangoCardColors.gray_400,
    logoColor: () => TangoCardColors.black_900
  }
}
</script>

<style lang="scss" scoped></style>
